<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('releveProduit.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component
      :messages="messages"
      :error="error"
      :messagesChampsVide="messagesChampsVide"
      :champsVide="champsVide"
      :title="'general.problemOccurred'"
      :withEmplyFields="true"
      @close="error = $event"/>
    <div class="mgt-40px">
      <div class="card">
        <header class="header-card">
          <p>{{$t('releveProduit.title')}}</p>
        </header>
        <div class="card-content">
          <div class="columns mg-0">
            <div class="column is-6">
              <b-field :label="$t('releveProduit.filter.reference')">
                <b-input v-model="filter.reference"></b-input>
              </b-field>
              <b-field :label="$t('releveProduit.filter.libelle')">
                <b-input v-model="filter.libelle"></b-input>
              </b-field>
              <agence-tag-input
                :label="$t('releveProduit.filter.agence')"
                :items="agenceSelectionnees"
                v-model="filter.agencesId">
              </agence-tag-input>
              <input-periode
                  v-model="filter.periodeVisualisation"
                  :label="$t('releveProduit.filter.periodeVisualisation')"
                  @input="recherche">
              </input-periode>
              <button class="button is-addOrEdit mgt-20px" @click="recherche">
                {{$t('releveProduit.buttons.filtrer')}}
              </button>
            </div>
            <div class="column is-6">
              <b-field :label="$t('releveProduit.action.type')">
                <b-select v-model="selectEdition" expanded>
                  <option
                    v-for="(edition, $index) in listeChoiceEdition"
                    :key="$index"
                    :value="edition">
                    {{ $t(edition.libelle) }}
                  </option>
                </b-select>
              </b-field>
              <div class="mgt-20px">
                <p class="has-text-weight-bold mgb-2">{{$t('releveProduit.selection')}}</p>
                <div
                  v-for="(item, index) in filteredItems"
                  :key="index"
                  class="level mg-0">
                  <span class="level-left">{{item.title}}</span>
                  <span class="level-right">{{item.nombre}}</span>
                </div>
                <div class="level mg-0 mgt-2">
                  <span class="has-text-weight-bold level-left">
                    {{$t('releveProduit.typeProduit.total')}}
                  </span>
                  <span class="has-text-weight-bold level-right">{{total}}</span>
                </div>
              </div>
              <div class='is-flex is-justify-content-center'>
                <button class="button is-addOrEdit mg-2"
                @click="checkPermissions(permCatalogue.editer) ? editionProduit('Pdf')
                    : showPopUpPermission()">
                  <p>{{$t('releveProduit.buttons.edition')}}</p>
                  <p class="mgl-2 is-size-7">{{$t('releveProduit.buttons.pdf')}}</p>
                </button>
                <button class="button is-addOrEdit mg-2"
                  @click="checkPermissions(permCatalogue.editer) ? editionProduit('Docx')
                    : showPopUpPermission()">
                  <p>{{$t('releveProduit.buttons.edition')}}</p>
                  <span class="mgl-2 is-size-7">{{$t('releveProduit.buttons.docx')}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns mgt-40px">
      <div v-for="(elem, index) in items" :key="index" class="column is-2">
        <div class="card">
          <header class="card-header pd-2">
            <p class="card-header-title">{{elem.title}}</p>
            <qd-switch
              class="card-header-icon"
              :value="elem.select"
              @input="select(elem.type)">
            </qd-switch>
          </header>
          <div v-if="elem.nombre !== 0" class="card-content">
            <div class="mgt-2" v-for="(produit ,index) in getFirst(elem.items)" :key="index">
              <router-link-blank
                  :message="`${produit.reference} - ${produit.libelle}`"
                  :to="{ name: elem.route,
                    params: { id: produit.id }
                  }">
              </router-link-blank>
            </div>
            <qd-collapse
                :open="false"
                position="is-bottom"
                aria-id="contentIdForA11y4">
                <template #trigger="props">
                    <a
                        aria-controls="contentIdForA11y4"
                        :aria-expanded="props.open">
                        <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
                        {{ !props.open ? 'Montrer les produits' : 'Cacher les produits' }}
                    </a>
                </template>
                <div
                  class="mgt-2"
                  v-for="(produit ,index) in elem.items.slice(numberWanted)"
                  :key="index">
                    <router-link-blank
                        :message="`${produit.reference} - ${produit.libelle}`"
                        :to="{ name: elem.route,
                          params: { id: produit.id }
                        }">
                    </router-link-blank>
                </div>
            </qd-collapse>
          </div>
          <div v-else class="card-content">
            <p>{{$t('releveProduit.noProduit')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import {
  CATEGORIE_SALON,
  CATEGORIE_SPONSORING,
  CATEGORIE_PRESSE,
  CATEGORIE_AUTRE,
} from '@/configuration/catalogue/produitConf';
import inProgress from '@/services/general/inProgress';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { getAll as getAllPresse } from '@/api/produit/produitPresse';
import { getAll as getAllSalon } from '@/api/produit/produitSalon';
import { getAll as getAllAutre } from '@/api/produit/produitAutre';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import { getAll as getAllRegroupementProduit } from '@/api/produit/regroupementProduit';
import { getAll as getAllSponsoring } from '@/api/produit/produitSponsoring';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import inputPeriode from '@/components/general/inputPeriode';
import AppBreadcrumb from '@/components/general/breadcrumb';
import formatDate from '@/services/general/formatIsoDate';
import cloneDeep from 'lodash/cloneDeep';
import { LISTE_CHOICE_EDITION_PARUTION } from '@/configuration/presse/parution/parutionConfig';
import edition from '@/api/edition';
import moment from 'moment';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationEdition from '@/services/presse/edition/validation';
import validationGeneral from '@/services/validation/validation';

const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  data() {
    return {
      permCatalogue: CATALOGUE,
      filter: {
        reference: '',
        libelle: '',
        periodeVisualisation: {
          dateDebut: moment().startOf('month').toDate(),
          dateFin: moment().endOf('month').toDate(),
        },
        agencesId: [],
      },
      listeChoiceEdition: LISTE_CHOICE_EDITION_PARUTION.filter(choice => choice.tousProduits),
      selectEdition: {},
      actions: [],
      produits: {},
      queries: {
        [CATEGORIE_PRESSE]: getAllPresse,
        [CATEGORIE_SALON]: getAllSalon,
        [CATEGORIE_SPONSORING]: getAllSponsoring,
        [CATEGORIE_AUTRE]: getAllAutre,
        Regroupement: getAllRegroupementProduit,
      },
      numberWanted: 8,
      messages: [],
      error: false,
      messagesChampsVide: [],
      champsVide: [],
    };
  },
  components: {
    inputPeriode,
    AppBreadcrumb,
    routerLinkBlank,
    errorMsgComponent,
    agenceTagInput,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      agenceSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
      societesInformations: 'societesInformations',
      societeActiveId: 'societeActiveId',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...CategorieVente.mapGetters({
      categorieProduit: 'categorieProduit',
    }),
    categories() {
      const categories = this.categorieProduit.filter(categorie => {
        return [
          CATEGORIE_SALON,
          CATEGORIE_SPONSORING,
          CATEGORIE_PRESSE,
          CATEGORIE_AUTRE].includes(categorie.code);
      });
      if (this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleRegroupementProduit.key)) {
        categories.push({
          code: 'Regroupement',
          routeDetail: 'c.bodac.catalogue-detailRegroupementProduit',
        });
      }
      return categories;
    },
    total() {
      return this.filteredItems.reduce((a, item) => a + item.nombre, 0);
    },
    items() {
      return Object.keys(this.produits).map(elem => {
        return {
          type: elem,
          title: this.$i18n.t(`releveProduit.typeProduit.${elem.toLocaleLowerCase()}`),
          route: this.produits[elem].detailRoutes,
          nombre: this.produits[elem].items.length,
          items: this.produits[elem].items,
          select: this.produits[elem].select,
        };
      });
    },
    filteredItems() {
      return this.items.filter(i => i.select);
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('releveProduit.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('releveProduit.title'), route: { name: 'l.bodac.catalogue-presse' }, isActive: true },
      ];
    },
  },
  methods: {
    ...Societe.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getFirst(array) {
      if (!Array.isArray(array)) return [];
      if (array.length < this.numberWanted) {
        return array;
      }
      return array.slice(0, this.numberWanted);
    },
    getAllIds() {
      const listeSupport = this.filteredItems.map(item => item.items.map(i => {
        const elt = {};
        elt.id = i.id;
        elt.codeRegleFacturation = i.regleFacturation?.code || '';
        elt.codeProduit = i.reference;
        return elt;
      })).flat(2);

      listeSupport.sort((a, b) => {
        if (a.codeRegleFacturation + a.codeProduit
        > b.codeRegleFacturation + b.codeProduit) {
          return 1;
        }
        return -1;
      });

      return listeSupport.map(item => item.id).flat(2);
    },
    select(key) {
      const selected = this.produits[key].select;
      this.produits[key].select = !selected;
    },
    async editionProduit(format) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: this.getAllIds(),
          extension: format,
          typeDonnee: this.selectEdition.typeDonnee,
          typeEdition: this.selectEdition.typeEdition ? this.selectEdition.typeEdition : '',
          parametresAdditionnels: this.filter.periodeVisualisation,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationEdition({ data: response }, this.messages);
          validationGeneral(this.$i18n, { data: response }, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async recherche() {
      const filterData = cloneDeep(this.filter);
      filterData.periodeVisualisation = {
        dateDebut: formatDate(this.filter.periodeVisualisation.dateDebut),
        dateFin: formatDate(this.filter.periodeVisualisation.dateFin),
      };
      filterData.avecFactureSurPeriode = 'True';
      filterData.societeId = this.societeActiveId;
      const query = {
        limit: NO_PAGINATION,
        page: 1,
        query: filterData,
      };
      const loadingComponent = this.$buefy.loading.open();
      try {
        const newProduits = {};
        const promises = this.categories.map(categorie => {
          return this.queries[categorie.code](cloneDeep(query));
        });
        const responses = await Promise.all(promises);
        this.categories.forEach((categorie, index) => {
          newProduits[categorie.code] = {
            items: responses[index].data.result.items,
            select: true,
            detailRoutes: categorie.routeDetail,
          };
        });
        this.produits = newProduits;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.selectEdition = this.listeChoiceEdition[0];
    try {
      await this.loadSocietes({});
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
        PARAMETRES_INTERNE_KEYS.moduleRegroupementProduit.key,
      ]);
      await this.recherche();
      this.setInformationPage(this.$t('pagePresse.editionMasse.page'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
